import {
  type Filter,
  FilterType,
  type ListFilter,
  type RangeFilter,
  type StaticListFilter,
  type TreeFilter,
} from '../../filters/types/filters';

export const isListFilter = (
  filter: Filter | undefined
): filter is ListFilter => {
  return filter?.type === FilterType.LIST;
};

export const isStaticListFilter = (
  filter: Filter | undefined
): filter is StaticListFilter => {
  return filter?.type === FilterType.STATIC_LIST;
};

export const isTreeFilter = (
  filter: Filter | undefined
): filter is TreeFilter => {
  return filter?.type === FilterType.TREE;
};

export const isRangeFilter = (
  filter: Filter | undefined
): filter is RangeFilter => {
  return filter?.type === FilterType.RANGE;
};
